<template>
    <div class="form form__selectlist">
        <div
            v-if="title"
            class="form__selectlist_title"
        >{{title}}
        </div>
        <template v-if="items.length">
            <div class="form__selectlist_list">
                <ul>
                    <li v-for="(item, index) in items" :key="index">
                        <div class="columns is-vcentered">
                            <div class="column">
                                <div class="form__selectlist_list_name">
                                    {{item.name}}
                                </div>
                            </div>
                            <template v-if="item.new">
                                <div class="column is-narrow">
                                    <component-button
                                        :name="'form-select-list-remove'"
                                        :class="'form__selectlist_list_actiontrash'"
                                        :icon="true"
                                        :icon-name="'trash-2'"
                                        :icon-raw="true"
                                        @click="removeItem(index)"
                                    ></component-button>
                                </div>
                            </template>
                        </div>
                    </li>
                </ul>
            </div>
        </template>
        <template v-else>
            <component-note>{{ $t('forms.select.title') }}</component-note>
        </template>
        <div
            class="form__selectlist_field"
            v-if="addCourse && !disabled"
        >
            <form-select
                :label="''"
                :items="selectItems"
                :name="'select'"
                :value="selectValue"
                :multiple="true"
                :size="'small'"
                :disabled="disabled"
                @input="addItem"
            />
        </div>
        <template v-if="!disabled">
            <div class="form__selectlist_hint">
                <template v-if="linkActive">
                    <component-button
                        :align="'left'"
                        :text="true"
                        :name="'form-select-list-link'"
                        :size="'tiny'"
                        @click="emitLink"
                    >{{ linkText }}</component-button>
                </template>
                <template v-if="allowSwitch">
                    <button
                        class="btn btn--text btn--small btn--primary form__selectlist_hint_button"
                        id="form-electlist-hint-switch"
                        @click="switchAddCourse"
                    >
                        <template v-if="addCourse">
                            {{ closeButtonText }}
                        </template>
                        <template v-else>
                            {{ openButtonText }}
                        </template>
                    </button>
                </template>
            </div>
        </template>
    </div>
</template>

<script>

import FormSelect from '@/components/default/forms/FormSelect'
import ComponentButton from '@/components/default/shared/ComponentButton'
import ComponentNote from '@/components/default/shared/ComponentNote'

export default {
  name: 'form-selectlist',
  components: {
    ComponentNote,
    ComponentButton,
    FormSelect
  },
  data () {
    return {
      addCourse: false
    }
  },
  props: {
    linkActive: {
      type: Boolean,
      default: false
    },
    linkText: {
      type: String,
      default: 'Link'
    },
    title: {
      type: String,
      default: '',
      required: true
    },
    items: {
      type: [Array, Object],
      required: true
    },
    selectItems: {
      type: [Array, Object],
      required: true
    },
    selectValue: {
      type: [Array, Object],
      required: true
    },
    closeButtonText: {
      type: String,
      default: function () {
        return this.$t('forms.select.buttons.close')
      }
    },
    openButtonText: {
      type: String,
      default: function () {
        return this.$t('forms.select.buttons.add')
      }
    },
    disabled: {
      type: Boolean,
      default: false
    },
    allowSwitch: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    switchAddCourse: function () {
      this.addCourse = !this.addCourse
    },
    addItem: function (data) {
      this.$emit('emit-add', data)
    },
    removeItem: function (key) {
      this.$emit('emit-remove', key)
    },
    emitLink () {
      this.$emit('emit-link')
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/default/forms/formselectlist";
</style>
